var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "presentation",
    focusable: "false",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ui-icon__outline",
    d: "M23 61c-1,1 -1,3 -1,4 0,1 0,3 1,4 1,1 2,1 4,1l106 0c2,0 3,0 4,-1 1,-1 1,-3 1,-4 0,-1 0,-3 -1,-4 -1,-1 -2,-1 -4,-1l-106 0c-2,0 -3,0 -4,1zm-22 -40c-1,1 -1,3 -1,4 0,1 0,3 1,4 1,1 3,1 4,1l150 0c1,0 3,0 4,-1 1,-1 1,-3 1,-4 0,-1 0,-3 -1,-4 -1,-1 -3,-1 -4,-1l-150 0c-1,0 -3,0 -4,1zm22 120c-1,1 -1,3 -1,4 0,1 0,3 1,4 1,1 2,1 4,1l106 0c2,0 3,0 4,-1 1,-1 1,-3 1,-4 0,-1 0,-3 -1,-4 -1,-1 -2,-1 -4,-1l-106 0c-2,0 -3,0 -4,1zm-22 -40c-1,1 -1,3 -1,4 0,1 0,3 1,4 1,1 3,1 4,1l150 0c1,0 3,0 4,-1 1,-1 1,-3 1,-4 0,-1 0,-3 -1,-4 -1,-1 -3,-1 -4,-1l-150 0c-1,0 -3,0 -4,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ui-icon__filled",
    d: "M22 140c0,-6 4,-10 10,-10l96 0c6,0 10,4 10,10 0,6 -4,10 -10,10l-96 0c-6,0 -10,-4 -10,-10zm-22 -120c0,-6 4,-10 10,-10l140 0c6,0 10,4 10,10 0,6 -4,10 -10,10l-140 0c-6,0 -10,-4 -10,-10zm22 40c0,-6 4,-10 10,-10l96 0c6,0 10,4 10,10 0,6 -4,10 -10,10l-96 0c-6,0 -10,-4 -10,-10zm-22 40c0,-6 4,-10 10,-10l140 0c6,0 10,4 10,10 0,6 -4,10 -10,10l-140 0c-6,0 -10,-4 -10,-10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignCenter);
export default __webpack_public_path__ + "static/media/align_center.0030703a.svg";
export { ForwardRef as ReactComponent };